exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logout-container {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  text-align: center;\n  cursor: pointer; }\n  .logout-container .logout-button {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 20px; }\n  .logout-container span {\n    vertical-align: middle;\n    font-size: 1.5em;\n    font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/offsidebar/offsidebar.component.scss
// module id = 1104
// module chunks = 7